import { Mail, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
export default function Contact() {
  return <section id="επικοινωνία" className="bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-3xl px-4">
        <Card className="border-border shadow-lg rounded-lg">
          <CardHeader className="pb-6 text-center">
            <div className="bg-primary/10 mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-lg">
              <ShieldCheck className="text-primary h-8 w-8" />
            </div>
            <CardTitle className="font-default text-foreground text-3xl font-bold md:text-4xl">
              Επικοινωνία & Υποστήριξη
            </CardTitle>
            <CardDescription className="mt-3 text-lg">
              Προστασία Δεδομένων & Εξυπηρέτηση Πελατών
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-8 text-center md:text-left">
            <div className="text-muted-foreground space-y-4 leading-relaxed">
              <p>
                Για ζητήματα που αφορούν την επεξεργασία των προσωπικών σας
                δεδομένων, την άσκηση των νόμιμων δικαιωμάτων σας (όπως το
                δικαίωμα πρόσβασης, διόρθωσης, διαγραφής ή φορητότητας), καθώς
                και για οποιαδήποτε άλλη διευκρίνιση σχετικά με την πολιτική
                απορρήτου μας, η ομάδα υποστήριξης της <strong>HotelDeals</strong>{" "}
                παραμένει στη διάθεσή σας.
              </p>
              <p>
                Δεσμευόμαστε να προστατεύουμε τα προσωπικά σας δεδομένα και να
                απαντάμε στα αιτήματά σας με διαφάνεια και σεβασμό προς την
                ισχύουσα νομοθεσία.
              </p>
            </div>

            <Separator />

            <div className="bg-secondary/30 border-border flex flex-col items-center justify-center space-y-6 rounded-lg border p-8">
              <p className="text-foreground text-center font-medium">
                Παρακαλούμε στείλτε το αίτημά σας απευθείας στο παρακάτω email:
              </p>
              
              <div className="bg-background border-border flex items-center gap-3 rounded-lg border px-6 py-4 shadow-sm">
                <Mail className="text-primary h-6 w-6 shrink-0" />
                <span className="font-default text-primary text-lg font-semibold md:text-xl">
                  [Εισάγετε Email Επικοινωνίας]
                </span>
              </div>

              <Button asChild size="lg" className="mt-2 rounded-lg">
                <Link to="mailto:[Εισάγετε Email Επικοινωνίας]">
                  Αποστολή Ηλεκτρονικού Μηνύματος
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}